export default {"src":"/_next/static/media/lounges.a07661a1.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};